export const equipmentRules =  {
  displayName: [
      v => !!v || 'Display Name is required',
  ],
  farmType: 
  [
      (v) => {
        if(!v || v == 'Choose farm or zone'){
          return "Farm Type is required";
        } 
        return true
      }
      //v => !!v || 'Farm Type is required'
      // (v)=> {if (v) return v.length <= 10 || 'Farm Type must be less than 10 characters'},
      // (v)=> {if (v) return  !Number(v) || 'Farm Type must not contain numbers'}
  ],
  farmId: [
    v => !!v || 'Farm / Segments is required',
    v => v !== 'Where will the equipment be used' || 'Farm / Segments is required',
  ],
  category: [
    v => !!v || 'Category is required',
  ],
  activity: [
    v => !!v || 'Activity is required',
  ],
  equipment: [
    v => !!v || 'Equipment is required',
  ],
  energyConsumption: [
    (v) => {
      if (!Number(v) && v != 0) {
        return "Energy Consumption should be number";
      }
      return true
    },
  ],
}